import { Button } from '@foam/buoy/src/components/Button/Button';
import { Icon } from '@foam/buoy/src/components/Icon/Icon';
import { Tooltip } from 'ui-components';
import { ContentCardPlatformIcon } from '~/components/ContentCard/components';
import { ISearchContentResult } from '~/searchApi';
import { formatAbbr } from '~/utils';

import { getMetricsToShow } from '../utils';

interface CreatorInfoSectionProps {
  content: ISearchContentResult;
  showMetrics: boolean;
  onClick?: (content: ISearchContentResult) => void;
}

export const CreatorInfoSection = ({
  content,
  showMetrics,
  onClick,
}: CreatorInfoSectionProps) => {
  const metricsToShow = getMetricsToShow(content);

  return (
    <div className="flex flex-1 shrink-0 flex-col justify-between gap-3 px-3 pb-3 pt-2">
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2 align-middle">
          <ContentCardPlatformIcon
            width={6}
            height={6}
            platform={content.platform}
          />
          <span className="truncate text-16 font-500 text-[var(--media-kit-text-base)]">
            {content.creator.fullName}
          </span>
        </div>

        {/* Metrics Row */}
        {showMetrics ? (
          <div className="flex flex-wrap items-center gap-2 text-14 text-[var(--media-kit-text-subtle)]">
            {metricsToShow.showView && (
              <Tooltip label="Views" placement="top">
                <div className="flex items-center gap-1">
                  <Icon name="Eye" />
                  <span>{formatAbbr(metricsToShow.viewValue)}</span>
                </div>
              </Tooltip>
            )}
            {metricsToShow.showReach && (
              <Tooltip label="Reach" placement="top">
                <div className="flex items-center gap-1">
                  <Icon name="Reach" />
                  <span>{formatAbbr(metricsToShow.reachValue)}</span>
                </div>
              </Tooltip>
            )}
            {metricsToShow.showEngagements && (
              <Tooltip label="Engagements" placement="top">
                <div className="flex items-center gap-1">
                  <Icon name="Click" />
                  <span>{formatAbbr(metricsToShow.engagementsValue)}</span>
                </div>
              </Tooltip>
            )}
            {metricsToShow.showLikes && (
              <Tooltip label="Likes" placement="top">
                <div className="flex items-center gap-1">
                  <Icon name="ThumbUp" />
                  <span className="text-14 text-root-text-color-subtle">
                    {formatAbbr(metricsToShow.likesValue)}
                  </span>
                </div>
              </Tooltip>
            )}
            {metricsToShow.showComments && (
              <Tooltip label="Comments" placement="top">
                <div className="flex items-center gap-1">
                  <Icon name="Chat" />
                  <span className="text-14 text-root-text-color-subtle">
                    {formatAbbr(metricsToShow.commentsValue)}
                  </span>
                </div>
              </Tooltip>
            )}
          </div>
        ) : null}
      </div>

      {/* View Details Button */}
      {showMetrics ? (
        <Button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClick?.(content);
          }}
          variant="tertiary"
          size="md"
          className="justify-self-end"
        >
          <Icon name="Stats" />
          View details
        </Button>
      ) : null}
    </div>
  );
};
